import React, { Component } from 'react'
import PartnerFilterForm from './PartnerFilterForm/PartnerFilterForm'
import { FilterContainer } from './styles'

class PartnerStatementsFilter extends Component {
  state = {
    currentValues: {},
    currentVehicle: ''
  }

  applyFilter = checkPlan =>
    checkPlan.id.toString() === this.props.accountPlans.activePlanId.toString()

  render() {
    const currentPlan = this.props.accountPlans.plans[0]
      ? this.props.accountPlans.plans.find(this.applyFilter)
      : ''

    const findCurrentVehicle = currentIdentifierId => {
      const currentIdentifier = currentPlan.identifiers.find(
        value => currentIdentifierId.toString() === value.carPlate.toString()
      )
      this.setState({
        currentVehicle: currentIdentifier
      })
    }

    const onSubmitFilter = values => {
      const changedValues = {
        plate: values.plate,
        month: values.month,
        type: values.type,
        year: values.year,
        periodo: values.periodo,
        diaDaSemana: values.diaDaSemana,
        rangeDates: values.rangeDates,
        quantidade: values.quantidade
      }

      if (this.props.onFilter) {
        this.props.onFilter(changedValues)
      }

      this.setState({
        isOpen: false,
        currentValues: changedValues
      })

      if (changedValues.plate) {
        findCurrentVehicle(changedValues.plate)
      }
    }

    if (
      currentPlan.identifiers &&
      currentPlan.identifiers.length === 1 &&
      this.state.currentVehicle === ''
    ) {
      this.setState({
        currentVehicle: currentPlan.identifiers[0]
      })
    }

    return (
      <FilterContainer isOpen={this.state.isOpen}>
        <PartnerFilterForm
          onSubmitFilter={onSubmitFilter}
          showResults={this.props.showResults}
          unsetResults={this.props.unsetResults}
        />
      </FilterContainer>
    )
  }
}

PartnerStatementsFilter.defaultProps = {
  visible: false
}
export default PartnerStatementsFilter



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/PartnerStatementsFilter.js